export function participantStatusLabel(status?: string | null): string {
  switch ((status ?? "").toLowerCase()) {
    case "active":
    case "confirmed":
      return "Activo";
    case "pre_registered":
      return "Pre-registrado";
    case "waitlisted":
      return "En espera";
    case "dropped":
      return "Baja";
    default:
      return status || "—";
  }
}

export function tournamentStatusLabel(status?: string | null): string {
  switch ((status ?? "").toLowerCase()) {
    case "active":
      return "Activo";
    case "draft":
      return "Borrador";
    case "archived":
    case "finished":
    case "completed":
    case "closed":
      return "Terminado";
    default:
      return status || "—";
  }
}

export function tournamentTypeLabel(type?: string | null): string {
  switch ((type ?? "").toLowerCase()) {
    case "ladder":
      return "Escalera";
    case "round_robin":
      return "Round Robin";
    case "elimination":
      return "Eliminatoria";
    default:
      return type || "—";
  }
}
